import { render, staticRenderFns } from "./user-image.vue?vue&type=template&id=c89d9194&"
import script from "./user-image.vue?vue&type=script&lang=js&"
export * from "./user-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports